import React from 'react';

import { MasterData } from 'models/api';

import { renderSelectField, renderIfFieldsHasError } from 'components/parts/FormParts'
import { Field, Fields } from 'redux-form';

type props = {
  masterData: MasterData | null, 
  submitFailed: boolean;
}

const DefaultStudyPlanForm: React.FC<props> = (props: props) => {

  return <div className="setting-box__form">
    <div className="form">
      <div className="form__item">
        <div className="form__label form__label--required">
          中学英語
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_junior_english">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.junior_english_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_junior_english' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>
      <div className="form__item">
        <div className="form__label form__label--required">
        中学数学
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_junior_math">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.junior_math_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_junior_math' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>
      <div className="form__item">
        <div className="form__label form__label--required">
        中学理科
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_junior_science">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.junior_science_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_junior_science' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>
      <div className="form__item form__item--text">
        <div className="form__label">
          英語
        </div>
        <div className="form__field">
          <div className="form__field-text">
            英文法・英文解釈・リーディング
          </div>
          {/* <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_english">
              <option value="">選択してください</option>
              {
                // MARK: 英語は受講しない設定は不可
                props.masterData && props.masterData.english_levels.filter(x => x.level !== null).map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            <Fields names={[ 'recommend_english' ]} component={renderIfFieldsHasError}>
              <div className="form__error">
                <div className="error-message">
                  選択してください。
                </div>
              </div>
            </Fields>
          </div> */}
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          英単語
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_english_words">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.english_words_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_english_words' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          数学
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_math">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.math_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            <Fields names={[ 'recommend_math' ]} component={renderIfFieldsHasError}>
              <div className="form__error">
                <div className="error-message">
                  選択してください。
                </div>
              </div>
            </Fields>
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          数学A（整数）
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_math_a">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.math_a_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_math_a' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          物理
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_physics">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.physics_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_physics' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }

          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          化学
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_chemistry">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.chemistry_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_chemistry' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          生物
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_biology">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.biology_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_biology' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          現代文
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_modern_japanese">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.modern_japanese_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_modern_japanese' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          古文
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_classical_japanese">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.classical_japanese_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_classical_japanese' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          世界史
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_world_history">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.world_history_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_world_history' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          日本史
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_japanese_history">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.japanese_history_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_japanese_history' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          歴史総合
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_modern_and_contemporary_history">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.modern_and_contemporary_history_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_modern_and_contemporary_history' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          地理
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_geography">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.geography_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_geography' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

      <div className="form__item">
        <div className="form__label form__label--required">
          公民
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_civics">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.civics_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={[ 'recommend_civics' ]} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>
      <div className="form__item">
        <div className="form__label form__label--required">
          情報
        </div>
        <div className="form__field">
          <div className="select form__select-wrapper">
            <Field
              component={renderSelectField}
              className="select__select select__select--required"
              name="recommend_information_study">
              <option value="">選択してください</option>
              {
                props.masterData && props.masterData.information_study_levels.map(
                  x => <option key={x.level || 0} value={x.level || 0}>{x.course_names}</option>)
              }
            </Field>

            {
              props.submitFailed &&
              <Fields names={['recommend_information_study']} component={renderIfFieldsHasError}>
                <div className="form__error">
                  <div className="error-message">
                    選択してください。
                  </div>
                </div>
              </Fields>
            }
          </div>
        </div>
      </div>

    </div>
  </div>

}

export default DefaultStudyPlanForm;
